module.exports = __webpack_public_path__ + "static/lawrence_edited-9152411aac5906edfda024d53f117d60.jpg";